import React from 'react';
import Banner from './Banner';
import Footer from '../Common/Footer.jsx';
import TaxServices from '../Services/TaxServices';
import AboutUs from '../Home/About_us.jsx';
import MapForm from '../Home/Map_form.jsx';
import OurLocations from './OurLocations';

const Home = () => {
    return (
        <>
            <Banner />
            <AboutUs/>
            <OurLocations/>
            <TaxServices/>
            <MapForm/>
            <Footer />
        </>
    )
}

export default Home;